import { Maybe } from "@figurepos/fgr-lib-business-logic/lib/common/types"
import { createGraphQLRequest } from "../../../../api/utils/httpRequest"
import type {
    AuditData,
    CategoryModifierResponse,
    ModifierLocationSaveRequestData,
    ModifierSaveRequestData,
    ResponseData,
} from "../../../../graphql/types"

export const fetchModifiers = (headers: Record<string, any>): Promise<Maybe<CategoryModifierResponse>> =>
    createGraphQLRequest({
        headers: headers,
        body: {
            query: `
                query itemsCategoriesModifiers {
                    itemsCategoriesModifiers {
                        data {
                             id
                             name
                             kitchenName
                             isActive
                             addedToGroups {
                                id
                                groupId
                                name
                                price
                                supplement
                            }
                        }
                        overrides {
                            locationId
                            data {
                                id
                                isActive
                                addedToGroups {
                                 id
                                 price
                                 supplement
                                }
                            }
                        }
                    }
                }
            `,
            operationName: "itemsCategoriesModifiers",
        },
    }).then(response => {
        if (response && response.data && response.data.itemsCategoriesModifiers) {
            return response.data.itemsCategoriesModifiers
        }

        return null
    })

export const modifierSave = (
    headers: Record<string, any>,
    data: ModifierSaveRequestData
): Promise<Maybe<ResponseData>> =>
    createGraphQLRequest({
        headers: headers,
        body: {
            query: `
                 mutation modifierSave($data: ModifierSaveRequestData!) {
                    modifierSave(data: $data) {
                        success
                    }
                }
            `,
            operationName: "modifierSave",
            variables: {
                data: data,
            },
        },
    }).then(response => {
        return response.data.modifierSave
    })

export const modifierLocationSave = (
    headers: Record<string, any>,
    data: ModifierLocationSaveRequestData
): Promise<Maybe<ResponseData>> =>
    createGraphQLRequest({
        headers: headers,
        body: {
            query: `
                 mutation modifierLocationSave($data: ModifierLocationSaveRequestData!) {
                    modifierLocationSave(data: $data) {
                      success
                    }
                }
            `,
            operationName: "modifierLocationSave",
            variables: {
                data: data,
            },
        },
    }).then(response => {
        return response.data.modifierLocationSave
    })

export const modifierDelete = (
    headers: Record<string, any>,
    id: string,
    auditData: AuditData
): Promise<Maybe<CategoryModifierResponse>> =>
    createGraphQLRequest({
        headers: headers,
        body: {
            query: `
                 mutation modifierDelete($id: String!, $auditData: AuditData) {
                    modifierDelete(id: $id, auditData: $auditData) {
                      success
                    }
                }
            `,
            operationName: "modifierDelete",
            variables: {
                id: id,
                auditData: auditData,
            },
        },
    }).then(response => {
        return response.modifierDelete
    })
